import { GET_POSTS_SUCCESS, GET_POSTS_FAILURE } from '../actions/action'

const initalState = {
    isFetching: false,
    items: {},
};

const posts = (state = [initalState], action) => {    
    switch (action.type) {
        case GET_POSTS_SUCCESS:
            return [
                ...state,
                {
                    isFetching: false,
                    items: action.posts
                }
            ]
        case GET_POSTS_FAILURE:
            return [
                ...state,
                {
                    isFetching: false,
                    items: {},
                    error: action.error,
                }
            ]
        default:
            return state

    }
}

export default posts
